import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/root/project/list/styles.scss';export default {
  "list": "_list_1b4o6_1",
  "main": "_main_1b4o6_9",
  "mainRoot": "_mainRoot_1b4o6_18",
  "header": "_header_1b4o6_23",
  "projectPopup": "_projectPopup_1b4o6_32",
  "iconBox": "_iconBox_1b4o6_36",
  "icon": "_icon_1b4o6_36",
  "folderIcon": "_folderIcon_1b4o6_56",
  "openedIcon": "_openedIcon_1b4o6_64",
  "popupIcon": "_popupIcon_1b4o6_74",
  "projectPopupMain": "_projectPopupMain_1b4o6_80",
  "row": "_row_1b4o6_87",
  "avatar": "_avatar_1b4o6_94",
  "col": "_col_1b4o6_99",
  "name": "_name_1b4o6_108",
  "deactivated": "_deactivated_1b4o6_117",
  "profession": "_profession_1b4o6_127",
  "recordList": "_recordList_1b4o6_132",
  "removedBadge": "_removedBadge_1b4o6_136"
};